import { Smartphone } from 'lucide-react';
import AppStoreButtons from './AppStoreButtons';
import AnimateIn from './AnimateIn';

function HeroBackground() {
  return (
    <div className="absolute inset-0">
      <div className="absolute top-[-20%] right-[-10%] w-[600px] h-[600px] rounded-full bg-deep-blue/60 blur-3xl" />
      <div className="absolute bottom-[-30%] left-[-15%] w-[500px] h-[500px] rounded-full bg-compliance-green/8 blur-3xl" />
      <div className="absolute top-[20%] left-[10%] w-[300px] h-[300px] rounded-full bg-soft-teal/5 blur-2xl" style={{ animation: 'pulse-soft 6s ease-in-out infinite' }} />
    </div>
  );
}

function HeroContent() {
  return (
    <div>
      <AnimateIn delay={0}>
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/10 rounded-full px-4 py-1.5 mb-6">
          <Smartphone size={14} className="text-compliance-green" />
          <span className="text-white/80 text-xs font-body font-medium">Available on iOS & Android</span>
        </div>
      </AnimateIn>
      <AnimateIn delay={100}>
        <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.1] text-white mb-5">
          Stay compliant.{' '}
          <span className="gradient-text">Stay organised.</span>{' '}
          Stay protected.
        </h1>
      </AnimateIn>
      <AnimateIn delay={200}>
        <p className="text-white/70 text-lg sm:text-xl font-body leading-relaxed mb-8 max-w-xl">
          The mobile-first compliance, tenancy, and documentation app for landlords and tenants in England's private rented sector.
        </p>
      </AnimateIn>
      <AnimateIn delay={300}>
        <AppStoreButtons variant="glass" />
      </AnimateIn>
      <AnimateIn delay={400}>
        <div className="mt-6 flex items-center gap-3">
          <a href="#waitlist" data-testid="hero-waitlist-link" className="text-soft-teal text-sm font-body font-medium hover:text-compliance-green transition-colors underline underline-offset-4 decoration-soft-teal/40">
            Join the waitlist for launch updates
          </a>
        </div>
      </AnimateIn>
      <AnimateIn delay={500}>
        <p className="mt-8 text-white/45 text-xs font-body">
          ActCheck is available through the mobile app. Download to get started.
        </p>
      </AnimateIn>
    </div>
  );
}

function HeroAppPreview() {
  return (
    <AnimateIn delay={300} direction="right">
      <div className="relative flex justify-center lg:justify-end">
        <div className="relative">
          <div className="absolute inset-0 actcheck-gradient rounded-3xl blur-2xl opacity-20 scale-105" />
          <img
            src="/app-screenshot.png"
            alt="ActCheck mobile app showing compliance dashboard, rights guidance, and tenancy management screens"
            className="relative w-full max-w-lg rounded-2xl"
            data-testid="hero-app-image"
          />
        </div>
      </div>
    </AnimateIn>
  );
}

export default function HeroSection() {
  return (
    <section data-testid="hero-section" className="relative min-h-[92vh] flex items-center overflow-hidden bg-navy">
      <HeroBackground />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16 w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <HeroContent />
          <HeroAppPreview />
        </div>
      </div>
    </section>
  );
}
